import React from 'react';
import { CellType } from '../../../../../enums';
import RankCell from '../cells/RankCell/RankCell';
import TextCell from '../cells/TextCell/TextCell';
import SchoolNameCell from '../cells/SchoolNameCell/SchoolNameCell';
import StudentNameCell from '../cells/StudentNameCell/StudentNameCell';
import NumberCell from '../cells/NumberCell/NumberCell';
import ProgressCell from '../cells/ProgressCell/ProgressCell';
import StarsCell from '../cells/StarsCell/StarsCell';
import StatusCell from '../cells/StatusCell/StatusCell';
import ParticipantsCell from '../cells/ParticipantsCell/ParticipantsCell';
import InstitutionIdCell from '../cells/InstitutionIdCell/InstitutionIdCell';
import MonsterCell from '../cells/MonsterCell/MonsterCell';
import RankingScoreCell from '../cells/RankingScoreCell/RankingScoreCell';
import DistrictCell from '../cells/DistrictCell/DistrictCell';
import ClassNameCell from '../cells/ClassNameCell/ClassNameCell';

const TableCell = ({ value, row, column, rowIndex }) => {

  const renderCell = () => {
    switch (column.type) {
      case CellType.RANK:
        return <RankCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.NUMBER:
        return <NumberCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.PROGRESS:
        return <ProgressCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.STARS:
        return <StarsCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.STATUS:
        return <StatusCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.PARTICIPANTS:
        return <ParticipantsCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.INSTITUTION_ID:
        return <InstitutionIdCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.TEXT_MONSTER:
        return <MonsterCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.RANKING_SCORE:
        return <RankingScoreCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.TEXT_SCHOOL_NAME:
        return <SchoolNameCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.TEXT_STUDENT_NAME:
        return <StudentNameCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.TEXT_DISTRICT:
        return <DistrictCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.CLASS_NAME:
        return <ClassNameCell value={value} row={row} column={column} rowIndex={rowIndex} />;
      case CellType.TEXT:
      case CellType.TEXT_CLASS_NAME:
      case CellType.TEXT_CITY:
      default:
        return <TextCell value={value} row={row} column={column} rowIndex={rowIndex} />;
    }
  };

  return renderCell();
};

export default TableCell;

